export default {
    state: {
        findJobs: false,
    },
    getters: {
        shouldFakeLoadFindJobs: state => payload => state.findJobs,
    },
    mutations: {
        startFindJobsFakeLoad(state) {
            state.findJobs = true;
            setTimeout(() => {
                state.findJobs = false;
            }, 1000);
        },
    },
};
